import { getItem, removeItem } from './ss.ts';

/** Global list of every key expected to be handled and recognizable ever */
const ALLOWED_QUERY_PARAMS = ['installation_id', 'state']

/**
 * Note: every value is assumed to be a opaque string type
 * having a static maximum length of 100 characters.
 * Each value has a basic XSS sanitation regex applied.
 */
export function sanitizeQueryParameters(search: string): string {
	const rawParams = new URLSearchParams(search)
	const newParams = new URLSearchParams()
	for (const key of ALLOWED_QUERY_PARAMS) {
		const rawValue = rawParams.get(key)
		if (rawValue) {
			const value = rawValue
				.trim()
				.replace(/<\/?[^>]+(>|$)/g, '')
				.substring(0, 100)
			newParams.set(key, value)
		}
	}
	const state = getItem('evetro:installationState')
	if (state && !newParams.get('state')) {
		newParams.set('state', state)
	}
	removeItem('evetro:installationState')
	const search2 = newParams.toString()
	if (search2) return '?'.concat(search2)
	return ''
}

export function isPathValid(pathname?: string) {
	if (!pathname) return false
	return (
		pathname.startsWith('/') &&
		!pathname.startsWith('/callback') &&
		!pathname.startsWith('/kthxbai') &&
		!pathname.includes('://') &&
		!pathname.includes('javascript:')
	)
}
